/* 
--- DEVELOPER WARNING ---
This is a generated file.
Any changes you make to this file will not be saved nor git tracked. 
*/

import textClassification from './textClassification/details.generated.js';
import teachableMachine from './teachableMachine/details.generated.js';
import tables from './tables/details.generated.js';
import simpleprg95grpexample from './simpleprg95grpexample/details.generated.js';
import selfieSegmentation from './selfieSegmentation/details.generated.js';
import projectProbe from './projectProbe/details.generated.js';
import poseHand from './poseHand/details.generated.js';
import poseFace from './poseFace/details.generated.js';
import poseBody from './poseBody/details.generated.js';
import onnxTest from './onnxTest/details.generated.js';
import objectDetection from './objectDetection/details.generated.js';
import extensionProbe from './extensionProbe/details.generated.js';
import complexprg95grpexample from './complexprg95grpexample/details.generated.js';
import chat from './chat/details.generated.js';
import appinventorprg95grpexample from './appinventorprg95grpexample/details.generated.js';
//CODE GENERATION IDENTIFIER:: Imports above
export default [
	textClassification,
	teachableMachine,
	tables,
	simpleprg95grpexample,
	selfieSegmentation,
	projectProbe,
	poseHand,
	poseFace,
	poseBody,
	onnxTest,
	objectDetection,
	extensionProbe,
	complexprg95grpexample,
	chat,
	appinventorprg95grpexample,
  //CODE GENERATION IDENTIFIER:: Exports above
];